export const VACATION_TAB_LABEL = 'Férias';
export const PAID_REST_TAB_LABEL = 'Descanso';

export const SUPPLIER_COLLABORATOR_TYPE = 'Fornecedor';

export function getVacationTabLabel(collaboratorType?: string | null): string {
    return collaboratorType === SUPPLIER_COLLABORATOR_TYPE
        ? PAID_REST_TAB_LABEL
        : VACATION_TAB_LABEL;
}
